import { Edit, Trash2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import {
  CardContent,
} from "../../../components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";

export const CategoriesList = ({
  filteredCategories,
  toggleStatus,
  handleEdit,
  handleDelete,
  loading,
}) => {
  if (loading) {
    return (
      <CardContent>
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="ml-2 text-gray-600">Loading categories...</span>
        </div>
      </CardContent>
    );
  }

  if (filteredCategories.length === 0) {
    return (
      <CardContent>
        <div className="text-center py-8 text-gray-500">
          <p>No categories found.</p>
          <p className="text-sm mt-1">Create your first category to get started.</p>
        </div>
      </CardContent>
    );
  }

  return (
    <div className="mt-5">
      {/* Categories Table */}
      <CardContent className="p-0">
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="font-semibold">Name</TableHead>
                <TableHead className="font-semibold">Status</TableHead>
                <TableHead className="font-semibold w-32">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredCategories.map((category) => (
                <TableRow key={category._id} className="hover:bg-gray-50">
                  <TableCell className="font-medium py-4">
                    {category.name || 'Unnamed Category'}
                  </TableCell>
                  <TableCell className="py-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium cursor-pointer transition-colors hover:opacity-80 ${
                        category.status
                          ? "bg-green-100 text-green-800 hover:bg-green-200"
                          : "bg-red-100 text-red-800 hover:bg-red-200"
                      }`}
                      onClick={() => toggleStatus(category._id)}
                      title={`Click to ${category.status ? 'deactivate' : 'activate'}`}
                    >
                      {category.status ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                  <TableCell className="py-4">
                    <div className="flex space-x-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleEdit(category)}
                        className="hover:bg-blue-50 hover:border-blue-300"
                        title="Edit category"
                      >
                        <Edit className="w-4 h-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDelete(category._id)}
                        className="text-red-600 hover:text-red-800 hover:bg-red-50 hover:border-red-300"
                        title="Delete category"
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </div>
  );
};